import { createContext } from "react";

export const useEnvironment = createContext<"dev" | "prod">("prod");
